import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconTactics2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTactics2"><Circle cx="6" cy="18" r="2.5" stroke="currentColor"/><Path d="M4 4L8 8M8 4L4 8" stroke="currentColor" strokeLinecap="square"/><Path d="M16 16L20 20M20 16L16 20" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 18H12V6H19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M17.5 3.5L20 6L17.5 8.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTactics2;
